/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */

export type GetSimListSortDirection =
  (typeof GetSimListSortDirection)[keyof typeof GetSimListSortDirection];

export const GetSimListSortDirection = {
  asc: "asc",
  desc: "desc",
} as const;
